import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { TextField, Button, Checkbox, Container, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { getUsername } from '../../context/AuthFunc';
import { useTranslation } from 'react-i18next';
import { addUnitOfMeasure } from '../../api/axios';
import UnitsOfMeasure from '../List/UnitsOfMeasure';

const NewUnitOfMeasure = () => {
    const { t } = useTranslation('global');

    const [name, setName] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    const [refreshKey, setRefreshKey] = useState(0);
    
    useEffect(()=>{
    },)

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!name){
            setErrMsg(t("newOrganizationUnit.nameRequired"));
            return;
        }
        const newUnitOfMeasure = {
            name,
        };
        try{
            const response = await addUnitOfMeasure(newUnitOfMeasure);
            if(!response.success){
                setErrMsg(t("newTicket.somethingWentWrong"));
                setTimeout(() => setErrMsg(''), 3000);
            }
            else{
                
                setSucc(t("newTicket.successfullyAdded"));
                setName('');
                
                setTimeout(() => setSucc(''), 3000);
                setRefreshKey((prev) => prev + 1);
            }
        }
        catch (error) {
            setErrMsg(t("newTicket.failedToAddTicket"));
        }
    };

    return (
    <Container maxWidth="sm" className="container-employee" sx={{ p: 3, flexShrink: 0 , mt: 4}} >
        <Typography variant="h4" sx={{ mb:4 }}>{t("unitOfMeasure.newUnitOfMeasure")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label={t("unitOfMeasure.name")}
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </Grid>            
            <Grid item xs={12} sx={{ width:"100%", display:"flex", justifyContent:"flex-end"}}>
                <Button sx={{ width:"50%" }} variant="contained" type="submit">{t("newTicket.add")}</Button>
            </Grid>
        </Grid>
    </form>

    {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
    {succ && <Success message={succ} onClose={() => setSucc('')} />}
    
    <UnitsOfMeasure key={refreshKey}/>

    </Container>
    );
};

export default NewUnitOfMeasure;
